import { NgModule } from '@angular/core';
import { HttpClientTestingModule } from '@angular/common/http/testing';
import { RouterTestingModule } from '@angular/router/testing';

import { AuthModule } from './auth.module';
import { AuthService } from './services';
import { MockAuthService } from './mocks';

@NgModule({
  imports: [AuthModule, RouterTestingModule, HttpClientTestingModule],
  providers: [{ provide: AuthService, useClass: MockAuthService }],
})
export class AuthTestingModule {}
